<template functional>
        <path d="M38.2109 5.51642C46.9134 5.51642 55.2593 8.97344 61.4129 15.127C67.5664 21.2805 71.0234 29.6265 71.0234 38.3289C71.0234 47.0313 67.5664 55.3773 61.4129 61.5309C55.2593 67.6844 46.9134 71.1414 38.2109 71.1414C29.5085 71.1414 21.1625 67.6844 15.009 61.5309C8.85546 55.3773 5.39844 47.0313 5.39844 38.3289C5.39844 29.6265 8.85546 21.2805 15.009 15.127C21.1625 8.97344 29.5085 5.51642 38.2109 5.51642ZM38.2109 75.8289C48.1566 75.8289 57.6948 71.878 64.7274 64.8454C71.7601 57.8128 75.7109 48.2745 75.7109 38.3289C75.7109 28.3833 71.7601 18.845 64.7274 11.8124C57.6948 4.7798 48.1566 0.828918 38.2109 0.828918C28.2653 0.828918 18.727 4.7798 11.6944 11.8124C4.66182 18.845 0.710938 28.3833 0.710938 38.3289C0.710938 48.2745 4.66182 57.8128 11.6944 64.8454C18.727 71.878 28.2653 75.8289 38.2109 75.8289ZM53.9287 30.6092C54.8369 29.701 54.8369 28.2068 53.9287 27.2986C53.0205 26.3904 51.5264 26.3904 50.6182 27.2986L33.5234 44.3934L25.8037 36.6736C24.8955 35.7654 23.4014 35.7654 22.4932 36.6736C21.585 37.5818 21.585 39.076 22.4932 39.9842L31.8682 49.3592C32.7764 50.2674 34.2705 50.2674 35.1787 49.3592L53.9287 30.6092Z" />
</template>





<script>

    export default {

        name: 'CircledCheckmark'

    }

</script>